export default __webpack_public_path__ + "images/loggedout/home/modularPage/learning_path-d453b978a900d632077d7f6947acafca.png";